import { typographyTokens } from '../../../theme/typographyTokens';
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Stack,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';

export const DrawerFilters = React.memo(
  ({
    setDrawOpen,
    isFilterData,
    dataFields,
    labelName,
    appliedFilter,
  }: any) => {
    const [selectedDataField, setSelectedDataField] = useState<any>(appliedFilter || null);

    // Sync with applied filter when drawer opens
  useEffect(() => {
      setSelectedDataField(appliedFilter || null);
    }, [appliedFilter]);

    const textFieldSx = {
      color: "#222222",
      width: "100%",
      "& > p": {
        margin: "5px 0px",
        color: "#646669",
        fontSize: typographyTokens.fontSizes.xs,
      },
    };
    const theme = useTheme();

    const handleApply = () => {
      if (selectedDataField) {
        const filterById: any = dataFields?.filter(
          (list: any) => list?.id === selectedDataField.id
        );
        setDrawOpen(false);
        return isFilterData(filterById, selectedDataField);
      }
      setDrawOpen(false);
    };

    return (
      <>
        <Box sx={{ width: 400, padding: "15px" }} role="presentation">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: typographyTokens.fontSizes.xl,
                fontWeight: typographyTokens.fontWeights.bold,
                padding: "15px",
              }}
            >
              Filters
            </Typography>
            <Button onClick={() => setDrawOpen(false)}>
              {" "}
              <i style={{ color: "gray" }} className="fa fa-close"></i>
            </Button>
          </Box>

          <Box>
            <Stack
              display="flex"
              direction="column"
              alignItems="left"
              spacing={4}
              sx={{ p: 4 }}
            >
              <Box>
                <Autocomplete
                  options={
                    [...(dataFields || [])].sort((a: any, b: any) =>
                      (a?.name || "").localeCompare(b?.name || "")
                    )
                  }
                  getOptionLabel={(option: any) =>
                    option ? option.name : ""
                  }
                  value={selectedDataField}
                  onChange={(_, newValue) => {
                    setSelectedDataField(newValue);
                  }}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.id === value?.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={textFieldSx}
                      size="small"
                      placeholder={`Search by ${labelName} Name`}
                      label={labelName}
                    />
                  )}
                  renderOption={(props, option: any) => (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  mt: 3,
                  justifyContent: "flex-end",
                  px: 2,
                }}
              >
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#2372B9",
                    font: "normal normal 600 16px/22px Open Sans",
                  }}
                  disabled={!selectedDataField}
                  onClick={handleApply}
                >
                  Apply
                </Button>
              </Box>
            </Stack>
          </Box>
        </Box>
      </>
    );
  }
);
